import React, { Component } from 'react'

class SpinnerLoad extends Component {

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-22 position-center margin-center">
              <div className="loader center">
                <i className="font-size-12 fas fa-spinner fa-spin"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpinnerLoad;



// WEBPACK FOOTER //
// src/components/SpinnerLoad.js